export default {"src":"/_next/static/image/public/images/ic_empty_cart.beaec080253ec23938e2bb7cac48e80d.svg","height":147,"width":129};